import React from 'react'

const applications = [
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/vrxq1k0nzx/jpeg/Soft_AD_ProdPho_Ill_Soft_AnchorDesignerSoftwareForACI318-ETAGandCSA-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmying',
    title: 'ADC',
    href: 'https://www2.strongtie.com/software/anchordesigner.html',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/nyoildiyra/jpeg/Soft_RDLC_ProdPho_Ill_Soft_RebarDevelopmentLengthCalculator-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'RDLC',
    href: 'https://www2.strongtie.com/webapps/rebardevelopmentlengthcalculator',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/uqa7ppknq6/jpeg/Soft_ACE_ProdPho_Ill_Soft_AdhesiveCartridgeEstimator-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'ACE',
    href: 'https://app.strongtie.com/ace',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/hr7rbeizsm/jpeg/Soft_PSG_ProdPho_Ill_Soft_ProductSubmittalGenerator-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'PSG',
    href: 'https://www.strongtie.com/resources/product-submittal-generator',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/egwnsrzaqy/jpeg/Soft_PFD_ProdPho_Ill_Soft_PostToFoundationDesigner-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'PFD',
    href: 'https://app.strongtie.com/pfd',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/yimpf2njoa/jpeg/Soft_DF_ProdPho_Ill_Soft_Drawing-DWG-DXF-Finder-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'DF',
    href: 'https://www.strongtie.com/search?v=%3Arelevance&tab=drawing',
  },
  {
    imgUrl:
      'https://ssttoolbox.widen.net/content/5akzjsl279/jpeg/Soft_ART_ProdPho_Ill_Soft_AnchorReferenceTool-Icon_C0.jpeg?w=250&h=250&position=c&color=ffffffff&quality=40&retina=true&u=cjmyin',
    title: 'ART',
    href: 'https://www2.strongtie.com/webapps/art',
  },
]

const RelatedApps = () => {
  return (
    <div className="related-apps-container">
      {applications.map((a) => (
        <a key={a.title} target="_blank" rel="noreferrer" href={a.href}>
          <img src={a.imgUrl} alt={a.title} />
        </a>
      ))}
    </div>
  )
}

export default RelatedApps
